import { AlertDefaults, IncidentsApi } from 'src/app/hickory-api';
import { AlertFields } from './alert-fields-helper';
import { AlertModelService } from '../alert-model.service';
import { AlertLocationHelper } from './alert-location-helper';
import { EventsService } from 'src/app/boxwood-api';
import { AlertPriorityHelper } from './alert-priority-helper';

export class AlertIncidentHelper {
  static postProcess(service: AlertModelService, alert: AlertDefaults = service.alertSettings, apiV1: IncidentsApi = service.incidentApiV1, apiV2: EventsService = service.incidentApiV2) {
    // check to make sure incident v1 still exists (handles deleted incidents on a RARF or template)
    if (alert.message?.incident?.id && apiV1) {
      alert.message.priority = AlertPriorityHelper.getAlertPriority(alert.message);
      service.subscription.add(
        apiV1.getIncidentById(alert.message?.incident?.id).subscribe({
          next: (_) => {
            // success: no op -- incident exists
          },
          error: (_) => {
            // error: incident no longer exists
            service.alertMessage.incidentId = null;
            service.alertMessage.incident = null;
            service.notifyFieldUpdated(AlertFields.INCIDENT_V1);
          },
        })
      );
    }

    // check to make sure incident v2 still exists (handles deleted incidents on a RARF or template)
    if (alert.message?.incidentEvent?.id && apiV2) {
      alert.message.priority = AlertPriorityHelper.getAlertPriority(alert.message);
      service.subscription.add(
        apiV2.getEventById({ id: alert.message?.incidentEvent?.id }).subscribe({
          next: (res) => {
            // success - incident exists
            AlertLocationHelper.setFacilitiesFromIncidentEvent(service, res);
          },
          error: (_) => {
            // error: incident no longer exists
            service.alertMessage.incidentEvent = null;
            service.notifyFieldUpdated(AlertFields.INCIDENT_V2);
          },
        })
      );
    }
  }

  static preparePreview(_service: AlertModelService, preview: AlertDefaults) {
    // make sure that message.incidentId is set correctly
    if (preview.message) {
      preview.message.incidentId = preview.message.incident?.id;
    }
  }
}
